import { Component } from "@angular/core";
import { Error401Component } from "../../components/error-401/error-401";
import { FullScreenLoaderComponent } from "../../components/full-screen-loader/full-screen-loader";
import { AuthFormComponent } from "../../components/auth/auth-form/auth-form";
import { MatCard, MatCardModule } from "@angular/material/card";
import { NgClass, NgIf, NgOptimizedImage } from "@angular/common";
import { ConfigProvider } from "../../../config-provider.service";
import { TranslateService } from "@ngx-translate/core";
import { MatIcon, MatIconModule } from "@angular/material/icon";


@Component({
  selector: 'privacy-terms-page',
  providers: [],
  styleUrls: ['./privacy-terms.scss'],
  standalone: true,
  imports: [
    Error401Component,
    FullScreenLoaderComponent,
    AuthFormComponent,
    MatCardModule,
    NgIf,
    NgOptimizedImage,
    NgClass,
    MatIconModule
  ],
  templateUrl: './privacy-terms.html'
})
export class PrivacyTermsPageComponent {

  public image = '';

  public isPrivacyEnOpened = false;
  public isPrivacyFrOpened = true;
  public isPrivacyItOpened = false;

  public privacyTitleEn = 'Privacy Policy';
  public privacyTitleFr = 'Politique de Confidentialité';
  public privacyTitleIt = 'Informativa sulla Privacy';

  constructor (
    public conf: ConfigProvider,
  ) {
    this.image = conf.assetsUrl + 'img/app-logo_color.png';
  }

  public onTitleClicked(lang: 'EN' | 'FR' |  'IT') {
    switch (lang) {
      case 'EN':
        this.isPrivacyEnOpened = !this.isPrivacyEnOpened;
        break;
      case 'FR':
        this.isPrivacyFrOpened = !this.isPrivacyFrOpened;
        break;
      case 'IT':
        this.isPrivacyItOpened = !this.isPrivacyItOpened;
        break;
    }
  }

}
